import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { useBiClickLogger } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
const GroupSearchInput = ({ filterValue , onFilterInputChange , className  })=>{
    const { t  } = useTranslation();
    const { setTrackingRef: setInputRef  } = useBiClickLogger(BiData({
        evid: 2,
        click_info: 'addToGroup.searchGroup',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue
    }));
    return /*#__PURE__*/ React.createElement(TextInput, {
        ref: setInputRef,
        id: "search-input",
        className: className,
        label: t('addToGroupPopup.input.filter.placeholder'),
        placeholder: t('addToGroupPopup.input.filter.placeholder'),
        value: filterValue,
        onChange: onFilterInputChange,
        prefix: /*#__PURE__*/ React.createElement(SearchIcon, {
            disableDefaultColors: true
        }),
        noBottomSpacing: true,
        isLabelHidden: true
    });
};
GroupSearchInput.displayName = 'GroupSearchInput';
export default GroupSearchInput;
